import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/digitaladbird/frontend/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/root/digitaladbird/frontend/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/digitaladbird/frontend/src/app/components/ContactTeaser.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/digitaladbird/frontend/src/app/components/CoreServicesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/digitaladbird/frontend/src/app/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/digitaladbird/frontend/src/app/components/TestimonialsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/digitaladbird/frontend/src/app/components/VideoSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/digitaladbird/frontend/src/components/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/digitaladbird/frontend/src/components/ui/AppLogo.tsx");
